
<span class="help-btn" *ngIf="!showHelp" (click)="showHelp = true;">Help</span>
<span class="help-btn" *ngIf="showHelp" (click)="showHelp = false;">Hide</span>
<div id="help-container">
    <ng-container *ngIf="showHelp">
        <p>This page is for testing ECC chat contact flows. The default values provided are for the test enviornment. If your chat does not display shortly after pressing the "Launch" button, consult the web console. (right click + inspect for most browsers. Then select the "console" tab.)</p>
    </ng-container>
</div>
<div class="content">
    <!-- left -->
    <div>
        <table>
            <tbody>
                <th>Set Default Environment Values</th>
                <tr>
                    <button class="buttonTwo" (click)="initializeConfig('dev')">Dev</button>
                    <button class="buttonTwo" (click)="initializeConfig('test')">Test</button>
                    <button class="buttonTwo" (click)="initializeConfig('uat')">UAT</button>
                </tr>
                <th>Agent Info</th>
                <tr>
                    <td>Display Name</td>
                    <td><input type="text" required placeholder="diplay name" [(ngModel)]="customerName"></td>
                </tr>
                <tr>
                    <td>Agent Email</td>
                    <td><input type="text" required placeholder="agent email" [(ngModel)]="email"></td>
                </tr>
                <tr>
                    <td>Policy #</td>
                    <td><input type="text" placeholder="policy number" [(ngModel)]="policyNumber"></td>
                </tr>
                <tr>
                    <td>Quote #</td>
                    <td><input type="text" placeholder="quote number" [(ngModel)]="quoteNumber"></td>
                </tr>
                <th>Chat Configuration</th>
                <tr>
                    <td>CFID</td>
                    <td><input type="text" required placeholder="contactFlowId" [(ngModel)]="contactFlowId"></td>
                </tr>
                <tr>
                    <td>Cnct Instance</td>
                    <td><input type="text" required placeholder="instanceId" [(ngModel)]="instanceId"></td>
                </tr>
                <tr>
                    <td>Chat Endpoint</td>
                    <td><input type="text" required placeholder="apiGatewayEndpoint" [(ngModel)]="apiGatewayEndpoint"></td>
                </tr>
                <tr>
                    <td>Host ASN</td>
                    <!-- <td><input type="text" placeholder="appName" [(ngModel)]="appName"></td> -->
                    <td>
                        <app-combo-box 
                            [(value)]="appName"
                            [options]="applicationOptions"
                            [disabled]="false">
                        </app-combo-box>
                    </td>
                </tr>
                <th>Auto Message</th>
                <tr>
                    <td>Enabled</td>
                    <td><input [(ngModel)]="autoMessageEnabled" type="checkbox" checked>{{autoMessageEnabled}}</td>
                </tr>
                <tr>
                    <td>Trigger text </td>
                    <td><input type="text"  placeholder="trigger text" [(ngModel)]="triggerText"></td>
                </tr>
                <tr>
                    <td>Response text</td>
                    <td><input type="text"  placeholder="response text" [(ngModel)]="responseText"></td>
                </tr>
                <th>Other</th>
                <tr>
                    <td>Chat Close Delay (ms)</td>
                    <td><input type="number" [(ngModel)]="closeChatDelay"></td>
                </tr>
            </tbody>
        </table>
        <button class="button" (click)="launch();">Launch</button>
        
        
    </div>


    <!-- right -->
    <div [ngClass]="displayClass">
        <div id="root"></div>
    </div>    
</div>
   